import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ICheckHasUnseenUserNotificationsResult extends IResult {
  hasUnseenNotifications: boolean;
}

export class CheckHasUnseenUserNotificationsRequest extends Request<{}, ICheckHasUnseenUserNotificationsResult> {
  constructor() {
    super('hasUnseenNotifications', {});
  }
}
